import Vue from "vue";
import store from '@/store'
import Router from "vue-router";
import Layout from "@/page/layout";
import Centre from "@/page/centre";
import Login from "@/views/login/index";
import Retrievepasswordd from "@/views/login/Retrievepasswordd";
import LookMember from "@/views/Management-list/look-member/index.vue";
//views下面的Management-list文件夹
import Merge from "@/views/Management-list/merge";
import Management from "@/views/Management-list/management/index.vue";
import Alterations from "@/views/Management-list/alterations/index.vue";
import MembersTurn from "@/views/Management-list/membersturn/index.vue";
import FreezeLevel from "@/views/Management-list/freezelevel/index.vue";
import Adjustment from "@/views/Management-list/adjustment/index.vue";
import ManagingHolds from "@/views/Management-list/managingholds/index.vue";
import MembershipBinding from "@/views/Management-list/membershipbinding/index.vue";
import Maintenance from "@/views/Management-list/maintenance/index.vue";
import Manager from "@/views/Management-list/manager/index.vue";
import WeChatBindingChange from "@/views/Management-list/WeChatBindingChange/index.vue";
import InForMations from "@/views/Management-list/Informations/index.vue";
//views下面的BasicSetting文件夹
import Templatetion from "@/views/BasicSetting/templatetion/index.vue";
import Stores from "@/views/BasicSetting/stores/index.vue";
import Custom from "@/views/BasicSetting/custom/index.vue";
import Define from "@/views/BasicSetting/define/index.vue";
import Products from "@/views/BasicSetting/product/index.vue";
// views下面的BusinessRule文件夹
import IntegrationRule from "@/views/BusinessRule/integrationrule/index.vue";
import CardRule from "@/views/BusinessRule/cardrule/index.vue";
import VoucherSet from "@/views/BusinessRule/voucherset/index.vue";
import Equities from "@/views/BusinessRule/equities/index.vue";
import Friends from "@/views/BusinessRule/friends/index.vue";
import GradeRule from "@/views/BusinessRule/graderule/index.vue";
import Operation from "@/views/BusinessRule/operation/index.vue";
// views下面的GIADAFriends文件夹
import Requisition from "@/views/GIADAFriends/requisition/index.vue";
import Administration from "@/views/GIADAFriends/administration/index.vue";
import Information from "@/views/GIADAFriends/information/index.vue";
import Qualification from "@/views/GIADAFriends/qualification/index.vue";
import Share from "@/views/GIADAFriends/share/index.vue";
import Product from "@/views/GIADAFriends/product/index.vue";
import Examine from "@/views/GIADAFriends/examine/index.vue";
import ExamineIntegrate from "@/views/GIADAFriends/examineIntegrate/index.vue";
import ExamineRecommend from "@/views/GIADAFriends/examineRecommend/index.vue";
import ExamineSales from "@/views/GIADAFriends/examineSales/index.vue";
// views下面的IntegralShop文件夹
import MasterData from "@/views/IntegralShop/masterdata/index.vue";
import GiftDataCreation from "@/views/IntegralShop/masterdata/giftdatacreation.vue";
import GiftDataViewing from "@/views/IntegralShop/masterdata/giftdataviewing.vue";
import Commodity from "@/views/IntegralShop/commodity/index.vue";
import Control from "@/views/IntegralShop/commodity/control.vue";
import GiftCertificate from "@/views/IntegralShop/commodity/giftcertificate.vue";
import ViewGift from "@/views/IntegralShop/commodity/viewgift.vue";
import GiftCreates from "@/views/IntegralShop/commodity/giftcreate.vue";
import VoucherCreates from "@/views/IntegralShop/commodity/vouchercreate.vue";
import VoucherChange from "@/views/IntegralShop/commodity/voucherchange.vue";
import GiftModify from "@/views/IntegralShop/commodity/giftmodify.vue";
import GiftSee from "@/views/IntegralShop/commodity/giftsee.vue";
import VoucherView from "@/views/IntegralShop/commodity/voucherview.vue";
import Copygiftcertificate from '@/views/IntegralShop/commodity/copygiftcertificate.vue'
import Copygiftmodify from '@/views/IntegralShop/commodity/copygiftmodify.vue'
import Copyvoucherchange from '@/views/IntegralShop/commodity/copyvoucherchange.vue'
import Conversion from "@/views/IntegralShop/conversion/index.vue";
import PointsShopping from "@/views/IntegralShop/conversion/Pointsshopping.vue";
import Giftdataviewxg from "@/views/IntegralShop/masterdata/giftdataviewxg.vue";
import CopyGiftdataviewxg from '@/views/IntegralShop/masterdata/copygiftdataviewxg.vue'
// views下面的CouponManagement文件夹
import Cash from "@/views/CouponManagement/cash/index.vue";
import GiadaFriendsCash from "@/views/CouponManagement/giadafriendscash/index.vue";
import DiscountCoupon from "@/views/CouponManagement/discountcoupon/index.vue";
import MerchandiseBond from "@/views/CouponManagement/merchandisebond/index.vue";
import Abnormal from "@/views/CouponManagement/abnormal/index.vue";
import Coupon from "@/views/CouponManagement/coupon/index.vue";
import IssuedStamps from "@/views/CouponManagement/issuedstamps/index.vue";
import IssuedSee from "@/views/CouponManagement/issuedstamps/see.vue";
import CashCreation from "@/views/CouponManagement/cashcreation/index.vue";
import ViewDetails from "@/views/CouponManagement/cashcreation/see.vue";
import VolumeCopy from "@/views/CouponManagement/cashcreation/copy.vue";
import VolumeUpdate from "@/views/CouponManagement/cashcreation/update.vue";
import disableEnable from "@/views/CouponManagement/cashcreation/disableEnable.vue";
import GiftCreate from "@/views/CouponManagement/giftcreate/index.vue";
import GiftLookup from "@/views/CouponManagement/giftcreate/see.vue";
import GiftUpdate from "@/views/CouponManagement/giftcreate/update.vue";
import GiftCopy from "@/views/CouponManagement/giftcreate/copy.vue";
import GiftdisableEnable from "@/views/CouponManagement/giftcreate/disableEnable.vue";
import IndustryCreate from "@/views/CouponManagement/industrycreate/index.vue";
import IndustryUpdate from "@/views/CouponManagement/industrycreate/update.vue";
import IndustryCopy from "@/views/CouponManagement/industrycreate/copy.vue";
import IndustrydisableEnable from "@/views/CouponManagement/industrycreate/disableEnable.vue";
import ManagementVouchers from "@/views/CouponManagement/managementvouchers/index.vue";
import AbnormalLook from "@/views/CouponManagement/abnormallook/index.vue";
import VoucherCreate from "@/views/CouponManagement/vouchercreate/index.vue";
import VoucherSee from "@/views/CouponManagement/vouchercreate/see.vue";
import VoucherUpdate from "@/views/CouponManagement/vouchercreate/update.vue";
import VoucherCopy from "@/views/CouponManagement/vouchercreate/copy.vue";
import VoucherdisableEnable from "@/views/CouponManagement/vouchercreate/disableEnable.vue";
import GiadaFriendsCashCreate from "@/views/CouponManagement/giadafriendscashcreate/index.vue";
import GiadaFriendsSee from "@/views/CouponManagement/giadafriendscashcreate/see.vue";
import GiadaFriendsUpdate from "@/views/CouponManagement/giadafriendscashcreate/update.vue";
import GiadaFriendscopy from "@/views/CouponManagement/giadafriendscashcreate/copy.vue";
import GiadadisableEnable from "@/views/CouponManagement/giadafriendscashcreate/disableEnable.vue";
import DiscountCouponCreate from "@/views/CouponManagement/discountcouponcreate/index.vue";
import RebateDetails from "@/views/CouponManagement/discountcouponcreate/see.vue";
import RebateUpdate from "@/views/CouponManagement/discountcouponcreate/update.vue";
import RebateCopy from "@/views/CouponManagement/discountcouponcreate/copy.vue";
import RebatedisableEnable from "@/views/CouponManagement/discountcouponcreate/disableEnable.vue";
// views下面的link-list文件夹
import MembershipVolume from "@/views/Link-list/MembershipVolume";
import VoucherTransferRecord from "@/views/Link-list/VoucherTransferRecord";
import ExchangeRecord from "@/views/Link-list/ExchangeRecord";
import ShoppingList from "@/views/Link-list/Shopping-list";
import Integrate from "@/views/Link-list/Integrate";
import WishList from "@/views/Link-list/WishList";
import LevelChange from "@/views/Link-list/LevelChange";
import InfoLevelChange from "@/views/Link-list/InfoLevelChange";
import Membership from "@/views/Link-list/Membership";
import Appointment from "@/views/Link-list/Appointment";
import Customer from "@/views/Link-list/Customer";
import Record from "@/views/Link-list/Record";
import Single from "@/views/Link-list/Single";
import Address from "@/views/Link-list/Address";
import Transactions from "@/views/Link-list/transactions";
import RecordTransactions from "@/views/Link-list/RecordTransactions";
import ProductDetails from "@/views/Link-list/ProductDetails";
import GetGiftList from "@/views/Link-list/GetGiftList";

//views下面的marketingcampaign文件夹
import ConditionalGrouping from "@/views/marketingcampaign/conditionalgrouping/index.vue";
import ConditionalLook from "@/views/marketingcampaign/conditionalgrouping/conditionallook.vue";
import ManagementActivities from "@/views/marketingcampaign/managementactivities/index.vue";
import ManualGroup from "@/views/marketingcampaign/manualgroup/index.vue";
//views下面的systemmanagement文件夹
import UserManagement from "@/views/systemmanagement/usermanagement/index.vue";
import Storeemployees from "@/views/systemmanagement/Storeemployees/index.vue";
import RoleDefinition from "@/views/systemmanagement/roledefinition/index.vue";
import DataDefinition from "@/views/systemmanagement/datadefinition/index.vue";
import PermissionQuery from "@/views/systemmanagement/permissionquery/index.vue";
import RetrievePassword from "@/views/systemmanagement/retrievepassword/index.vue";
// views下面的companyBrandSwitching文件夹
import BrandSwitching from "@/views/companyBrandSwitching/BrandSwitching.vue";


// views下面的ChangePassword文件夹 修改密码
import ChangePassword from "@/views/ChangePassword/index.vue";


// views下面的reportForm文件夹
import MemberReportForm from "@/views/reportForm/memberReportForm/index.vue";
import Memberopensource from "@/views/reportForm/Memberopensource/index.vue";
import GiftCertificateReportForm from "@/views/reportForm/giftCertificateReportForm/index.vue";
import CustomerwishlistForm from "@/views/reportForm/CustomerwishlistForm/index.vue";
import Changingclotheslist from "@/views/reportForm/Changingclotheslist/index.vue";
import Membersalessummary from "@/views/reportForm/Membersalessummary/index.vue";
import MemberConsumptionReport from "@/views/reportForm/MemberConsumptionReport/index.vue";
import EnterpriseWeChatFriendship from "@/views/reportForm/EnterpriseWeChatFriendship/index.vue";
import MonthlyCustSalesDataAnalysis from "@/views/reportForm/MonthlyCustSalesDataAnalysis/index.vue";


// views 下面的Logquery文件夹
import Interfacelogquery from "@/views/Logquery/Interfacelogquery/index.vue";
// views 下面的WeComs文件夹
import Wecomcustomer from "@/views/WeComs/wecomcustomer/index.vue";
//路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);
const router = new Router({
  routes: [
    // 首页
    {
      path: "/Layout",
      // name: "Layout",
      component: Layout,
      children: [{
        path: "/",
        name: "Centre",
        component: Centre,
      },
      {
        path: "/LookMember",
        name: "LookMember",
        component: LookMember,
      },
      {
        path: "/Merge",
        name: "Merge",
        component: Merge,
      },
      {
        path: "/Management",
        name: "Management",
        component: Management,
      },
      {
        path: "/Alterations",
        name: "Alterations",
        component: Alterations,
      },
      {
        path: "/MembersTurn",
        name: "MembersTurn",
        component: MembersTurn,
      },
      {
        path: "/Stores",
        name: "Stores",
        component: Stores,
      },
      {
        path: "/Templatetion",
        name: "Templatetion",
        component: Templatetion
      },
      {
        path: "/Custom",
        name: "Custom",
        component: Custom,
      },
      {
        path: "/Define",
        name: "Define",
        component: Define,
      },
      {
        path: "/Products",
        name: "Products",
        component: Products,
      },
      {
        path: "/IntegrationRule",
        name: "IntegrationRule",
        component: IntegrationRule,
      },
      {
        path: "/CardRule",
        name: "CardRule",
        component: CardRule,
      },
      {
        path: "/VoucherSet",
        name: "VoucherSet",
        component: VoucherSet,
      },
      {
        path: "/Equities",
        name: "Equities",
        component: Equities,
      },
      {
        path: "/Friends",
        name: "Friends",
        component: Friends,
      },
      {
        path: "/GradeRule",
        name: "GradeRule",
        component: GradeRule,
      },
      {
        path: "/Operation",
        name: "Operation",
        component: Operation,
      },

      {
        path: "/Requisition",
        name: "Requisition",
        component: Requisition,
      },
      {
        path: "/Administration",
        name: "Administration",
        component: Administration,
      },
      {
        path: "/Qualification",
        name: "Qualification",
        component: Qualification,
      },
      {
        path: "/Share",
        name: "Share",
        component: Share,
      },
      {
        path: "/Product",
        name: "Product",
        component: Product,
      },
      {
        path: "/Examine",
        name: "Examine",
        component: Examine,
      },
      {
        path: "/ExamineIntegrate",
        name: "ExamineIntegrate",
        component: ExamineIntegrate,
      },
      {
        path: "/ExamineRecommend",
        name: "ExamineRecommend",
        component: ExamineRecommend,
      },
      {
        path: "/ExamineSales",
        name: "ExamineSales",
        component: ExamineSales,
      },
      {
        path: "/Cash",
        name: "Cash",
        component: Cash,
      },
      {
        path: "/GiadaFriendsCash",
        name: "GiadaFriendsCash",
        component: GiadaFriendsCash,
      },
      {
        path: "/DiscountCoupon",
        name: "DiscountCoupon",
        component: DiscountCoupon,
      },
      {
        path: "/MerchandiseBond",
        name: "MerchandiseBond",
        component: MerchandiseBond,
      },
      {
        path: "/GiftCreate",
        name: "GiftCreate",
        component: GiftCreate,
      },
      {
        path: "/GiftLookup",
        name: "GiftLookup",
        component: GiftLookup,
      },
      {
        path: "/GiftUpdate",
        name: "GiftUpdate",
        component: GiftUpdate,
      },
      {
        path: "/GiftdisableEnable",
        name: "GiftdisableEnable",
        component: GiftdisableEnable,
      },
      {
        path: "/GiftCopy",
        name: "GiftCopy",
        component: GiftCopy,
      },
      {
        path: "/IndustryCreate",
        name: "IndustryCreate",
        component: IndustryCreate,
      },
      {
        path: "/IndustryUpdate",
        name: "IndustryUpdate",
        component: IndustryUpdate,
      },
      {
        path: "/IndustryCopy",
        name: "IndustryCopy",
        component: IndustryCopy,
      },
      {
        path: "/IndustrydisableEnable",
        name: "IndustrydisableEnable",
        component: IndustrydisableEnable,
      },
      {
        path: "/ManagementVouchers",
        name: "ManagementVouchers",
        component: ManagementVouchers,
      },
      {
        path: "/AbnormalLook",
        name: "AbnormalLook",
        component: AbnormalLook,
      },
      {
        path: "/VoucherCreate",
        name: "VoucherCreate",
        component: VoucherCreate,
      },
      {
        path: "/VoucherSee",
        name: "VoucherSee",
        component: VoucherSee,
      },
      {
        path: "/VoucherUpdate",
        name: "VoucherUpdate",
        component: VoucherUpdate,
      },
      {
        path: "/VoucherCopy",
        name: "VoucherCopy",
        component: VoucherCopy,
      },
      {
        path: "/VoucherdisableEnable",
        name: "VoucherdisableEnable",
        component: VoucherdisableEnable,
      },
      {
        path: "/GiadaFriendsCashCreate",
        name: "GiadaFriendsCashCreate",
        component: GiadaFriendsCashCreate,
      },
      {
        path: "/GiadaFriendsUpdate",
        name: "GiadaFriendsUpdate",
        component: GiadaFriendsUpdate,
      },
      {
        path: "/GiadaFriendscopy",
        name: "GiadaFriendscopy",
        component: GiadaFriendscopy,
      },
      {
        path: "/GiadadisableEnable",
        name: "GiadadisableEnable",
        component: GiadadisableEnable,
      },
      {
        path: "/GiadaFriendsSee",
        name: "GiadaFriendsSee",
        component: GiadaFriendsSee,
      },
      {
        path: "/DiscountCouponCreate",
        name: "DiscountCouponCreate",
        component: DiscountCouponCreate,
      },
      {
        path: "/RebateDetails",
        name: "RebateDetails",
        component: RebateDetails,
      },
      {
        path: "/RebateUpdate",
        name: "RebateUpdate",
        component: RebateUpdate,
      },
      {
        path: "/RebateCopy",
        name: "RebateCopy",
        component: RebateCopy,
      },
      {
        path: "/RebatedisableEnable",
        name: "RebatedisableEnable",
        component: RebatedisableEnable,
      },
      {
        path: "/Abnormal",
        name: "Abnormal",
        component: Abnormal,
      },
      {
        path: "/Coupon",
        name: "Coupon",
        component: Coupon,
      },
      {
        path: "/IssuedStamps",
        name: "IssuedStamps",
        component: IssuedStamps,
      },
      {
        path: "/IssuedSee",
        name: "IssuedSee",
        component: IssuedSee,
      },
      {
        path: "/CashCreation",
        name: "CashCreation",
        component: CashCreation,
      },
      {
        path: "/VolumeUpdate",
        name: "VolumeUpdate",
        component: VolumeUpdate,
      },
      {
        path: "/disableEnable",
        name: "disableEnable",
        component: disableEnable,
      },
      {
        path: "/VolumeCopy",
        name: "VolumeCopy",
        component: VolumeCopy,
      },
      {
        path: "/ViewDetails",
        name: "ViewDetails",
        component: ViewDetails,
      },
      {
        path: "/MasterData",
        name: "MasterData",
        component: MasterData,
      },
      {
        path: "/GiftDataCreation",
        name: "GiftDataCreation",
        component: GiftDataCreation,
      },
      {
        path: "/GiftDataViewing",
        name: "GiftDataViewing",
        component: GiftDataViewing,
      },
      {
        path: "/Commodity",
        name: "Commodity",
        component: Commodity,
      },
      {
        path: "/Control",
        name: "Control",
        component: Control,
      },
      {
        path: "/GiftCertificate",
        name: "GiftCertificate",
        component: GiftCertificate,
      },
      {
        path: "/ViewGift",
        name: "ViewGift",
        component: ViewGift,
      },
      {
        path: "/GiftCreates",
        name: "GiftCreates",
        component: GiftCreates,
      },
      {
        path: "/VoucherCreates",
        name: "VoucherCreates",
        component: VoucherCreates,
      },
      {
        path: "/VoucherChange",
        name: "VoucherChange",
        component: VoucherChange,
      },
      {
        path: "/GiftModify",
        name: "GiftModify",
        component: GiftModify,
      },
      {
        path: "/GiftSee",
        name: "GiftSee",
        component: GiftSee,
      },
      {
        path: "/VoucherView",
        name: "VoucherView",
        component: VoucherView,
      },
      {
        path: "/Conversion",
        name: "Conversion",
        component: Conversion,
      },
      {
        path: "/PointsShopping",
        name: "PointsShopping",
        component: PointsShopping,
      },
      {
        path: "/Giftdataviewxg",
        name: "Giftdataviewxg",
        component: Giftdataviewxg,
      },
      {
        path: "/CopyGiftdataviewxg",
        name: "CopyGiftdataviewxg",
        component: CopyGiftdataviewxg,
      },
      {
        path: "/Copygiftcertificate",
        name: "Copygiftcertificate",
        component: Copygiftcertificate,
      },
      {
        path: "/Copygiftmodify",
        name: "Copygiftmodify",
        component: Copygiftmodify,
      },
      {
        path: "/Copyvoucherchange",
        name: "Copyvoucherchange",
        component: Copyvoucherchange,
      },

      {
        path: "/FreezeLevel",
        name: "FreezeLevel",
        component: FreezeLevel,
      },
      {
        path: "/Adjustment",
        name: "Adjustment",
        component: Adjustment,
      },
      {
        path: "/ManagingHolds",
        name: "ManagingHolds",
        component: ManagingHolds,
      },
      {
        path: "/MembershipBinding",
        name: "MembershipBinding",
        component: MembershipBinding,
      },
      {
        path: "/Maintenance",
        name: "Maintenance",
        component: Maintenance,
      },
      {
        path: "/Manager",
        name: "Manager",
        component: Manager,
      },
      {
        path: "/WeChatBindingChange",
        name: "WeChatBindingChange",
        component: WeChatBindingChange,
      },
      {
        path: "/InForMations",
        name: "InForMations",
        component: InForMations,
      },
      {
        path: "/Information",
        name: "Information",
        component: Information,
      },
      {
        path: "/ConditionalGrouping",
        name: "ConditionalGrouping",
        component: ConditionalGrouping,
      },
      {
        path: "/ConditionalLook",
        name: "ConditionalLook",
        component: ConditionalLook,
      },
      {
        path: "/ManagementActivities",
        name: "ManagementActivities",
        component: ManagementActivities,
        meta: {
          keepAlive: false
        }
      },
      {
        path: "/ManualGroup",
        name: "ManualGroup",
        component: ManualGroup,
      },
      {
        path: "/UserManagement",
        name: "UserManagement",
        component: UserManagement,
      },
      {
        path: "/Storeemployees",
        name: "Storeemployees",
        component: Storeemployees,
      },
      {
        path: "/RoleDefinition",
        name: "RoleDefinition",
        component: RoleDefinition,
      },
      {
        path: "/DataDefinition",
        name: "DataDefinition",
        component: DataDefinition,
      },
      {
        path: "/PermissionQuery",
        name: "PermissionQuery",
        component: PermissionQuery,
      },
      {
        path: "/RetrievePassword",
        name: "RetrievePassword",
        component: RetrievePassword,
      },
      {
        path: "/ShoppingList",
        name: "ShoppingList",
        component: ShoppingList,
      },
      {
        path: "/ExchangeRecord",
        name: "ExchangeRecord",
        component: ExchangeRecord,
      },
        {
          path: "/GetGiftList",
          name: "GetGiftList",
          component: GetGiftList,
        },
      {
        path: "/MembershipVolume",
        name: "MembershipVolume",
        component: MembershipVolume,
      },
      {
        path: "/VoucherTransferRecord",
        name: "VoucherTransferRecord",
        component: VoucherTransferRecord,
      },
      {
        path: "/Integrate",
        name: "Integrate",
        component: Integrate,
      },
      {
        path: "/WishList",
        name: "WishList",
        component: WishList,
      },
      {
        path: "/LevelChange",
        name: "LevelChange",
        component: LevelChange,
      },
      {
        path: "/InfoLevelChange",
        name: "InfoLevelChange",
        component: InfoLevelChange,
      },
      {
        path: "/Membership",
        name: "Membership",
        component: Membership,
      },
      {
        path: "/Appointment",
        name: "Appointment",
        component: Appointment,
      },
      {
        path: "/Customer",
        name: "Customer",
        component: Customer,
      },
      {
        path: "/Record",
        name: "Record",
        component: Record,
      },
      {
        path: "/Single",
        name: "Single",
        component: Single,
      },
      {
        path: "/Address",
        name: "Address",
        component: Address,
      },
      {
        path: "/Transactions",
        name: "Transactions",
        component: Transactions,
      },
      {
        path: "/RecordTransactions",
        name: "RecordTransactions",
        component: RecordTransactions,
      },
      {
        path: "/ProductDetails",
        name: "ProductDetails",
        component: ProductDetails,
      },
      {
        path: "/BrandSwitching",
        name: "BrandSwitching",
        component: BrandSwitching
      },
      //会员报表
      {
        path: "/MemberReportForm",
        name: "MemberReportForm",
        component: MemberReportForm,
      },
      // 会员开源开散报表
      {
        path: "/Memberopensource",
        name: "Memberopensource",
        component: Memberopensource
      },
      //礼券报表
      {
        path: "/GiftCertificateReportForm",
        name: "GiftCertificateReportForm",
        component: GiftCertificateReportForm
      },
      {
        path: "/CustomerwishlistForm",
        name: "CustomerwishlistForm",
        component: CustomerwishlistForm
      },
      {
        path: "/Changingclotheslist",
        name: "Changingclotheslist",
        component: Changingclotheslist
      },
      {
        path: "/Membersalessummary",
        name: "Membersalessummary",
        component: Membersalessummary
      },
      //会员消费同比报表
      {
        path: "/MemberConsumptionReport",
        name: "MemberConsumptionReport",
        component: MemberConsumptionReport
      },
      // 客户企微好友关系报表
      {
        path: "/EnterpriseWeChatFriendship",
        name: "EnterpriseWeChatFriendship",
        component: EnterpriseWeChatFriendship
      },
        // 客户企微好友关系报表
        {
          path: "/MonthlyCustSalesDataAnalysis",
          name: "MonthlyCustSalesDataAnalysis",
          component: MonthlyCustSalesDataAnalysis
        },
      // 修改密码
      {
        path: "/ChangePassword",
        name: "ChangePassword",
        component: ChangePassword
      },
      // 接口日志查询
      {
        path: "/Interfacelogquery",
        name: "Interfacelogquery",
        component: Interfacelogquery
      }
// 企微管理
        ,
        {
          path: "/Wecomcustomer",
          name: "Wecomcustomer",
          component: Wecomcustomer,
        }
      ],

    },
    // 找回密码页面
    {
      path: "/Retrievepasswordd",
      name: "Retrievepasswordd",
      component: Retrievepasswordd
    },
    // 默认打开浏览器跳转到登录页面
    {
      path: "/",
      name: "Login",
      component: Login,
    },

  ],

});
// 添加导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') return next();
  if (to.path === '/Retrievepasswordd') return next();
  const token = store.getters.token
  if (!token) return next('/');
  next();
})
export default router